import { platform } from '@/utils/getPlatform';
import testAlipayExtJson from '../../build/config/ext-test.json'; // 支付宝小程序开发环境ext.json
const ENV = process.env.VUE_APP_ENV; // dev - 开发环境;  test - 测试环境;  prod - 正式环境  gray - 灰度发布
export const isProd = ENV === 'prod' || ENV === 'gray';
const ext = uni.getExtConfigSync && uni.getExtConfigSync();
export const extConfig = process.env.NODE_ENV === 'development' && platform === 'MP-ALIPAY' ? testAlipayExtJson.ext : ext;




export const captchaId = '78bdd2d82e4c441794ad6e40b06711fa'; // 网易易盾验证码captchaId
const version = '2021年7月13日20:09 版本号：3.1.0'; // 当前版本
const configMap = {























  H5: {
    // h5
    clientType: 'wap',
    appId: isProd ? 'wx8e0f1a29e301d9a3' : 'wx46b78f83a7f88488', // 水羊潮妆公众号测试（syoungmall）
    pid: '156t@80a0a788cb2e4b2', // 监控pid
    tenantId: 'soyoung',
    extTenantId: 'soyoung',
  },












};
export { configMap };
export default {
  ENV,
  IS_PROD: isProd,
  CLIENT_TYPE: configMap[platform].clientType,
  APPID: configMap[platform].appId,
  TENANT_ID: configMap[platform].tenantId,
  EXT_TENANT_ID: configMap[platform].extTenantId,
  STATIC_PATH: 'https://static.syounggroup.com',
  tntInstId: extConfig && extConfig.tntInstId,
  sceneId: extConfig && extConfig.sceneId,
  extConfig,
  VERSION: version,
};
